import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { settingsService } from '../services/settingsService';   
import { SettingsState } from '../models/state/settingsState';
import { SettingsMenuModel } from '../models/models/settingsMenuModel';

const initialState: SettingsState = {
    menu: {
        token: null,
        status: 'idle',
        isLoading: false,
        error: null,
        message: '',
        blobData: null,
        data:null,
      },
    profile: {
        token: null,
        status: 'idle',
        isLoading: false,
        error: null,
        message: '',
        blobData: null,
        data:null,
      },
};
 

export const getUserMenu = createAsyncThunk<
    any, 
    void,
  { rejectValue: string }
  >('settings/getUserMenu', async (_, { rejectWithValue }) => {
  try {
    const response = await settingsService.getUserMenu();
    return response;
  } catch (error: any) {
    return rejectWithValue('An unexpected error occurred');
  }
}); 

export const getUserProfile = createAsyncThunk<
    any, 
    void,
  { rejectValue: string }
  >('settings/getUserProfile', async (_, { rejectWithValue }) => {
  try {
    const response = await settingsService.getUserProfile();
    return response;
  } catch (error: any) {
    return rejectWithValue('An unexpected error occurred');
  }
}); 

const settingsReducer = createSlice({
  name: 'settings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserMenu.pending, (state) => {
        state.menu.status = 'loading';
        state.menu.isLoading = true;
      })
      .addCase(getUserMenu.fulfilled, (state, action) => {
        state.menu.status = 'idle';
        state.menu.data = action.payload;
        state.menu.isLoading = false; 
      })
      .addCase(getUserMenu.rejected, (state, action) => {
        state.menu.status = 'failed';
        state.menu.isLoading= false;
        if (action.payload) {
          state.menu.error = action.payload;
          state.menu.message = action.payload;
        } else {
          state.menu.message = 'An unexpected error occurred';
        }
      })
      .addCase(getUserProfile.pending, (state) => {
        state.profile.status = 'loading';
        state.profile.isLoading = true;
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.profile.status = 'idle';
        state.profile.data = action.payload;
        state.profile.isLoading = false; 
      })
      .addCase(getUserProfile.rejected, (state, action) => {
        state.profile.status = 'failed';
        state.profile.isLoading= false;
        if (action.payload) {
          state.profile.error = action.payload;
          state.profile.message = action.payload;
        } else {
          state.profile.message = 'An unexpected error occurred';
        }
      });
  },
});

export default settingsReducer.reducer; 
